import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { contactLogSchema, type ContactLogFormData } from '../schemas/contactLogSchema'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import { Textarea } from '@/components/ui/Textarea'
import { Button } from '@/components/ui/Button'

interface ContactLogFormProps {
  initialData?: any
  onSubmit: (data: ContactLogFormData) => Promise<void>
  onCancel: () => void
  loading?: boolean
}

export function ContactLogForm({ initialData, onSubmit, onCancel, loading }: ContactLogFormProps) {
  const { register, handleSubmit, formState: { errors } } = useForm<ContactLogFormData>({
    resolver: zodResolver(contactLogSchema),
    defaultValues: initialData,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Select
        label="Contact Method"
        {...register('contact_method')}
        options={[
          { value: 'phone', label: 'Phone' },
          { value: 'email', label: 'Email' },
          { value: 'text', label: 'Text' },
          { value: 'in_person', label: 'In Person' },
        ]}
        error={errors.contact_method?.message}
        required
      />

      <Input
        label="Person Contacted"
        {...register('person_contacted')}
        error={errors.person_contacted?.message}
      />

      <Textarea
        label="Summary"
        {...register('summary')}
        error={errors.summary?.message}
        required
      />

      <Input
        label="Outcome"
        {...register('outcome')}
        error={errors.outcome?.message}
        placeholder="e.g., Payment promised, No answer, Voicemail"
        required
      />

      <Input
        label="Next Action"
        {...register('next_action')}
        error={errors.next_action?.message}
        placeholder="What to do next..."
      />

      <Input
        label="Follow-Up Date"
        type="date"
        {...register('followup_date')}
        error={errors.followup_date?.message}
      />

      <div className="flex justify-end space-x-3 pt-4">
        <Button type="button" variant="secondary" onClick={onCancel}>Cancel</Button>
        <Button type="submit" loading={loading}>Add Contact</Button>
      </div>
    </form>
  )
}
